(ns practitest.frontend.components2.run-status
  (:require [re-frame.core :as re-frame]
            [practitest.frontend.subs :as subs]
            ["react-select" :default Select :refer [components]]
            [practitest.frontend.common.i18n :refer [get-translation]]))

(def no-run-status "NO RUN")

(def statuses-map
  {"PENDING"       {:translation-key "run-status.pending" :default "Pending"
                    :color "var(--pt-color-status-pending)"}
   "RUNNING"       {:translation-key "run-status.running" :default "Running"
                    :color "var(--pt-color-status-running)"}
   "PASSED"        {:translation-key "run-status.passed" :default "Passed"
                    :color "var(--pt-color-success)"}
   "FAILED"        {:translation-key "run-status.failed" :default "Failed"
                    :color "var(--pt-color-error)"}
   "CANCELED"      {:translation-key "run-status.canceled" :default "Canceled"
                    :color "var(--pt-color-status-canceled)"}
   "ERROR"         {:translation-key "run-status.error" :default "Error"
                    :color "var(--pt-color-status-error)"}
   no-run-status   {:translation-key "run-status.no-run" :default "No Run"
                    :color "var(--pt-color-status-no-run)"}
   "NOT INCLUDED"  {:translation-key "run-status.not-included" :default "Not Included"
                    :color "var(--pt-color-border-light)"}
   "BLOCKED"       {:translation-key "run-status.blocked" :default "Blocked"
                    :color "var(--pt-color-status-blocked)"}
   "NOT COMPLETED" {:translation-key "run-status.not-completed" :default "Not Completed"
                    :color "var(--pt-color-status-not-completed)"}
   "N/A"           {:translation-key "run-status.na" :default "N/A"
                    :color "var(--pt-color-status-na)"}})

(defn get-status-label
  [status]
  (when status
    (if-let [{:keys [translation-key default]} (get statuses-map status)]
      (get-translation translation-key default)
      (str "UNMAPPED STATUS " status))))

(defn get-status-color
  ([status]
   (get-status-color status false))
  ([status is-et]
   (let [status-colors @(re-frame/subscribe [::subs/status-colors])]
     (if is-et (get status-colors status) (:color (get statuses-map status))))))

(defn run-status-component
  [status]
  [:<>
   [:span.status-indicator
    {:style {:color (get-status-color status)}}]
   (get-status-label status)])
